import ResearchPage from "./pages/ResearchPage/ResearchPage";
import Navigation from "../Home/components/Navigation";
import LanderFooter from "./components/LanderFooter/LanderFooter";
import "./LanderRoot.css";

export default function LanderResearchPage() {
  return (
    <div className="lander-root research-shell">
      <Navigation />
      <ResearchPage />
      <LanderFooter showCta={false} />
    </div>
  );
}
